import styled, { css } from "styled-components";

export const Td = styled.td`
  border: 1px solid #e6e6e6;
  padding: 8px 15px;
  font-size: 14px;
  font-weight: 400;
  vertical-align: middle;
  ${props =>
    css`
      ${props.costomStyles};
    `} ${props => (props.onClick ? "cursor: pointer;" : "")};
`;
Td.displayName = "Td";

export default Td;



// WEBPACK FOOTER //
// ./src/legacy-tv-ui/Td/Td.js